import { Autocomplete, Box, Button, Drawer, FormHelperText, Stack, TextField, Tooltip, Typography } from '@mui/material'
import React, { Component } from 'react'
import '../pharmaReports.css';
import { Colors } from '../../../../Styles/Colors';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DataGrid } from '@mui/x-data-grid';
import { CommonGridToolBarWithFilterText } from '../../../../Components/Common Components/CommonComponents';
import { formatDate, AmountFormat } from '../../../../Components/CommonFunctions/CommonFunctions';
import { withTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import { CurrencySymbol } from '../../../../Utility/Constants';

class StockValue extends Component {

  constructor(props) {
    super(props)
    this.state = {
      stockValueData: [],
      page: 0,
      pageSize: 10,
      rowCount: 0,
      filterDatas: {
        'fromDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        'toDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        "dateIndex": 1,
        'drugName': '',
        'genericName': '',
        'quantityFrom': '',
        'quantityTo': '',
        "days": 30,
        "dosageType": [],
      },
      pageName: 'stockValue',
      filterOpen: false,
      purchaseValue: 0,
      salesValue: 0,
      openFrom: false,
      openTo: false,
      setMonth: 1,
      dosageTypeList: [],
      columnVisibilityModel: {
        purchase_qty: false,
        sales_return_qty: false,
        transfered_in_qty: false,
        stock_corrected_in: false,
        sales_qty: false,
        purchase_return_qty: false,
        transfered_out_qty: false,
        stock_corrected_out: false,
      }
    }
  }

  componentDidMount() {
    this.getStockValueData()
    this.getDosageTypeList()
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  renderFilter = (data) => {
    this.setState({
      filterDatas: data,
      filterOpen: false,
    }, () => { this.getStockValueData() })
  }

  ClosePopUp() {
    this.setState({
      filterOpen: false,
    })
  }

  clearFilter = (data) => {
    this.setState({
      filterDatas: data
    })
  }

  gridToolBar = () => {
    var { t } = this.props
    let TextArray = [
      { label: "From Date", value: formatDate(this.state.filterDatas.fromDate) },
      { label: "To Date", value: formatDate(this.state.filterDatas.toDate) },
    ]
    return (
      <Box emed_tid="stock_value_toolbar">
        <CommonGridToolBarWithFilterText FilterTextArray={TextArray} noExport={true} emed_tid="stock_value_toolbar_filter" />
      </Box>

    )
  }

  getDosageTypeList = () => {
    try {
      RestAPIService.getAll(Serviceurls.PHARMA_DOSAGE_TYPE_LIST)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              dosageTypeList: response.data.data
            })
          }
        }).catch((error) => {
          if (error.response.data.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getStockValueData = () => {
    try {
      this.LoaderFunction(true)
      let url = ''
      if (this.props.fromOT) {
        url = Serviceurls.OT_STOCK_VALUE_DETAIL + `?from_date=${this.state.filterDatas?.fromDate}&to_date=${this.state.filterDatas?.toDate}&dosage_type=${this.state.filterDatas?.dosageType ? this.state.filterDatas?.dosageType : ""}`
      } else if (this.props.fromSubLocation) {
        url = Serviceurls.SUBLOC_STOCK_VALUE_DETAIL + `?from_date=${this.state.filterDatas?.fromDate}&to_date=${this.state.filterDatas?.toDate}&dosage_type=${this.state.filterDatas?.dosageType ? this.state.filterDatas?.dosageType : ""}`
      } else {
        url = Serviceurls.PHARMA_INVENTORY_STOCK_VALUE_REPORT_GET + `?from_date=${this.state.filterDatas?.fromDate}&to_date=${this.state.filterDatas?.toDate}&mode=batch&dosage_type=${this.state.filterDatas?.dosageType ? this.state.filterDatas?.dosageType : ""}`
      }
      RestAPIService.getAll(url)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              stockValueData: response.data.data,
              purchaseValue: response.data?.total_purchase_price,
              salesValue: response.data?.total_mrp_value
            }, () => { this.LoaderFunction(false) })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.LoaderFunction(false)
            this.errorMessage(error.response.data.message)
          } else {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getStockValueExcel = () => {
    try {
      this.setState({ disableBtn: true })
      let url = ''
      if (this.props.fromOT) {
        url = Serviceurls.OT_STOCK_VALUE_DETAIL + `?from_date=${this.state.filterDatas?.fromDate}&to_date=${this.state.filterDatas?.toDate}&dosage_type=${this.state.filterDatas?.dosageType}&export_type=excel`
      } else if (this.props.fromSubLocation) {
        url = Serviceurls.SUBLOC_STOCK_VALUE_DETAIL + `?from_date=${this.state.filterDatas?.fromDate}&to_date=${this.state.filterDatas?.toDate}&dosage_type=${this.state.filterDatas?.dosageType}&export_type=excel`
      } else {
        url = Serviceurls.PHARMA_INVENTORY_STOCK_VALUE_REPORT_GET + `?from_date=${this.state.filterDatas?.fromDate}&to_date=${this.state.filterDatas?.toDate}&mode=batch&dosage_type=${this.state.filterDatas?.dosageType}&export=excel`
      }
      RestAPIService.excelGet(url).
        then((response) => {
          if (response.data) {
            var pom = document.createElement('a');
            var csvContent = response.data; //here we load our csv data 

            let filename = response.headers["content-disposition"]?.split("filename=")[1]
            // var blob = new Blob([csvContent], {type: 'data:application/vnd.ms-excel;base64'});

            var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
            var url = URL.createObjectURL(blob);
            pom.href = url;
            pom.setAttribute('download', filename ? filename : 'registry.xlsx');
            pom.click();
            this.setState({ disableBtn: false })
          }
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMessage(error.response?.data?.message);
          } else {
            this.errorMessage(error.message);
          }
          this.setState({ disableBtn: false })
        })
    } catch (error) {
      this.errorMessage(error.message);
      this.setState({ disableBtn: false })
    }
  }


  StockValuePrint = () => {
    this.setState({ disabled: true })
    try {
      let url = ''
      if (this.props.fromOT) {
        url = Serviceurls.OT_STOCK_VALUE_DETAIL + `?from_date=${this.state.filterDatas?.fromDate}&to_date=${this.state.filterDatas?.toDate}&dosage_type=${this.state.filterDatas?.dosageType}&export_type=pdf`
      } else if (this.props.fromSubLocation) {
        url = Serviceurls.SUBLOC_STOCK_VALUE_DETAIL + `?from_date=${this.state.filterDatas?.fromDate}&to_date=${this.state.filterDatas?.toDate}&dosage_type=${this.state.filterDatas?.dosageType}&export_type=pdf`
      } else {
        url = Serviceurls.PHARMA_INVENTORY_STOCK_VALUE_REPORT_GET + `?from_date=${this.state.filterDatas?.fromDate}&to_date=${this.state.filterDatas?.toDate}&mode=batch&dosage_type=${this.state.filterDatas?.dosageType}&export=pdf`
      }
      RestAPIService.getAll(url).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ disabled: false })
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
          this.setState({ disabled: false })
        })
    } catch (error) {
      this.errorMessage(error.message)
      this.setState({ disabled: false })
    }
  }

  checkFilterValidation = () => {
    try {
      let message = null;
      let states = this.state

      if (states.filterDatas?.toDate < states.filterDatas?.fromDate) {
        message = 'To Date Should Be Greater Than From Date'
      }
      return message;
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  FilterDate = (From, To, Index) => {
    this.state.filterDatas.fromDate = From
    this.state.filterDatas.toDate = To
    this.state.filterDatas.dateIndex = Index
    this.setState({ filterDatas: this.state.filterDatas }, () => this.getStockValueData())
  }

  renderFilterScreen = () => {
    const { t } = this.props
    return (
      <Box component={"div"} className='eMed_rts_filter_container' emed_tid="stock_value_filter_container">
        <Box component={"div"} className='eMed_filter_Top' emed_tid="stock_value_filter_header">
          <Typography variant='h6' fontWeight={600} emed_tid="stock_value_filter_title">{t("Filter")}</Typography>
          <Button onClick={() => { this.setState({ filterOpen: false }) }} className='eMed_usrconf_btn' emed_tid="stock_value_filter_close_btn">
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' emed_tid="stock_value_filter_close_icon" />
          </Button>
        </Box>
        <Box className='eMed_rts_middle' emed_tid="stock_value_filter_content">
          <Autocomplete
            freeSolo
            size='small'
            sx={{ width: '13.5vw', m: '0.5vw' }}
            multiple
            limitTags={1}
            disableCloseOnSelect
            disablePortal
            options={this.state.dosageTypeList}
            getOptionLabel={(option) => option}
            value={this.state.filterDatas.dosageType}
            onChange={(e, value) => {
              if (value && value?.length <= 7) {
                this.state.filterDatas.dosageType = value
                this.setState({ filterDatas: this.state.filterDatas })
              }
            }}
            renderInput={(params) =>
              <TextField
                {...params}
                label='Select Dosage Type'
                helperText={this.state.isTextFocused && this.state.filterDatas.dosageType?.length === 7 ? 'Maximum Options Selected' : ''}
                FormHelperTextProps={{
                  style: {
                    color: 'red',
                  },
                }}
                emed_tid="stock_value_filter_dosage_type_input"
              />}
            renderOption={(props, option, index) => (
              <li {...props} key={option} emed_tid={`stock_value_filter_dosage_type_option_${index}`}>
                <div emed_tid={`stock_value_filter_dosage_type_option_text_${index}`}>{option}</div>
              </li>
            )}
            emed_tid="stock_value_filter_dosage_type_autocomplete"
          />
        </Box>
        <Stack spacing={2} direction="row" alignItems="center" justifyContent="center" emed_tid="stock_value_filter_footer">
          <Button variant='outlined' size="small"
            onClick={() => {
              this.setState({
                filterDatas: {
                  fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                  toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                  dateIndex: 1,
                  dosageType: []
                },
              }, () => this.getStockValueData())
            }}
            id="eMed_Config_btn"
            emed_tid="stock_value_filter_clear_btn">{t("Clear")}</Button>
          <Button variant='contained' size="small"
            onClick={() => {
              this.getStockValueData()
              this.setState({ filterOpen: false })
            }}
            id="eMed_Config_btn"
            emed_tid="stock_value_filter_search_btn">{t("Search")}</Button>
        </Stack>
      </Box>
    )
  }


  render() {
    const { t } = this.props
    this.state.stockValueData.forEach((element, index) => element.sno = index + 1)
    const columns = [
      {
        field: 'brand_name', headerName: "Drug Details", flex: 0.083,
        renderCell: (params) => {
          let dosageTypeAndStr = `${params?.row?.dosagetype ? params?.row?.dosagetype : '-'} | ${params?.row?.drug_strength ? params?.row?.drug_strength : '-'}`
          return (
            <Box component={'div'} emed_tid={`stock_value_drug_details_${params.row.sno}`}>
              {params?.row?.brand_name ? params?.row?.brand_name?.length > 10 ?
                <Tooltip placement='top' title={params?.row?.brand_name} emed_tid={`stock_value_brand_name_tooltip_${params.row.sno}`}><Typography fontSize={'0.9vw'} fontWeight={600} emed_tid={`stock_value_brand_name_truncated_${params.row.sno}`}>{params?.row?.brand_name?.slice(0, 10) + '...'}</Typography></Tooltip>
                : <Typography fontSize={'0.9vw'} fontWeight={600} emed_tid={`stock_value_brand_name_full_${params.row.sno}`}>{params?.row?.brand_name ? params?.row?.brand_name : '-'}</Typography> : <Typography fontSize={'0.9vw'} fontWeight={600} emed_tid={`stock_value_brand_name_empty_${params.row.sno}`}>'-'</Typography>}
              {dosageTypeAndStr ? dosageTypeAndStr?.length > 10 ?
                <Tooltip placement='top' title={dosageTypeAndStr} emed_tid={`stock_value_dosage_type_tooltip_${params.row.sno}`}><Typography fontSize={'0.8vw'} color={Colors.grayShade} emed_tid={`stock_value_dosage_type_truncated_${params.row.sno}`}>{dosageTypeAndStr?.slice(0, 10) + '...'}</Typography></Tooltip>
                : <Typography fontSize={'0.8vw'} color={Colors.grayShade} emed_tid={`stock_value_dosage_type_full_${params.row.sno}`}>{dosageTypeAndStr ? dosageTypeAndStr : '-'}</Typography> : <Typography fontSize={'0.8vw'} color={Colors.grayShade} emed_tid={`stock_value_dosage_type_empty_${params.row.sno}`}>'-'</Typography>}
            </Box>
          )
        },valueGetter: ({ row }) => {
              const brandName = row?.brand_name || "";
              const genericName = row?.dosagetype || ""; 
              const strength = row?.drug_strength || "";     
              return `${brandName} ${genericName} ${strength}`;
      }
      },
      {
        field: 'opening_qty', headerName: 'Opening Qty', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_opening_qty_${params.row.sno}`}>{params?.row?.opening_qty ? params?.row?.opening_qty?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.opening_qty} emed_tid={`stock_value_opening_qty_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_opening_qty_truncated_${params.row.sno}`}>{params?.row?.opening_qty?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_opening_qty_full_${params.row.sno}`}>{params?.row?.opening_qty}</Typography> : <Typography emed_tid={`stock_value_opening_qty_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'stock_in_quantity', headerName: 'Stock In Qty', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_stock_in_quantity_${params.row.sno}`}>{params?.row?.stock_in_quantity ? params?.row?.stock_in_quantity?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.stock_in_quantity} emed_tid={`stock_value_stock_in_quantity_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_stock_in_quantity_truncated_${params.row.sno}`}>{params?.row?.stock_in_quantity?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_stock_in_quantity_full_${params.row.sno}`}>{params?.row?.stock_in_quantity}</Typography> : <Typography emed_tid={`stock_value_stock_in_quantity_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'purchase_qty', headerName: 'Purchase Qty', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_purchase_qty_${params.row.sno}`}>{params?.row?.purchase_qty ? params?.row?.purchase_qty?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.purchase_qty} emed_tid={`stock_value_purchase_qty_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_purchase_qty_truncated_${params.row.sno}`}>{params?.row?.purchase_qty?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_purchase_qty_full_${params.row.sno}`}>{params?.row?.purchase_qty}</Typography> : <Typography emed_tid={`stock_value_purchase_qty_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'sales_return_qty', headerName: 'Sales Return Qty', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_sales_return_qty_${params.row.sno}`}>{params?.row?.sales_return_qty ? params?.row?.sales_return_qty?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.sales_return_qty} emed_tid={`stock_value_sales_return_qty_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_sales_return_qty_truncated_${params.row.sno}`}>{params?.row?.sales_return_qty?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_sales_return_qty_full_${params.row.sno}`}>{params?.row?.sales_return_qty}</Typography> : <Typography emed_tid={`stock_value_sales_return_qty_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'transfered_in_qty', headerName: 'Transferred In Qty', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_transfered_in_qty_${params.row.sno}`}>{params?.row?.transfered_in_qty ? params?.row?.transfered_in_qty?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.transfered_in_qty} emed_tid={`stock_value_transfered_in_qty_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_transfered_in_qty_truncated_${params.row.sno}`}>{params?.row?.transfered_in_qty?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_transfered_in_qty_full_${params.row.sno}`}>{params?.row?.transfered_in_qty}</Typography> : <Typography emed_tid={`stock_value_transfered_in_qty_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'stock_corrected_in', headerName: 'Stock Corrected In Qty', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_stock_corrected_in_${params.row.sno}`}>{params?.row?.stock_corrected_in ? params?.row?.stock_corrected_in?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.stock_corrected_in} emed_tid={`stock_value_stock_corrected_in_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_stock_corrected_in_truncated_${params.row.sno}`}>{params?.row?.stock_corrected_in?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_stock_corrected_in_full_${params.row.sno}`}>{params?.row?.stock_corrected_in}</Typography> : <Typography emed_tid={`stock_value_stock_corrected_in_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'stock_out', headerName: 'Stock Out', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_stock_out_${params.row.sno}`}>{params?.row?.stock_out ? params?.row?.stock_out?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.stock_out} emed_tid={`stock_value_stock_out_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_stock_out_truncated_${params.row.sno}`}>{params?.row?.stock_out?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_stock_out_full_${params.row.sno}`}>{params?.row?.stock_out}</Typography> : <Typography emed_tid={`stock_value_stock_out_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'sales_qty', headerName: 'Sales Qty', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_sales_qty_${params.row.sno}`}>{params?.row?.sales_qty ? params?.row?.sales_qty?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.sales_qty} emed_tid={`stock_value_sales_qty_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_sales_qty_truncated_${params.row.sno}`}>{params?.row?.sales_qty?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_sales_qty_full_${params.row.sno}`}>{params?.row?.sales_qty}</Typography> : <Typography emed_tid={`stock_value_sales_qty_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'purchase_return_qty', headerName: 'Purchase Return Qty', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_purchase_return_qty_${params.row.sno}`}>{params?.row?.purchase_return_qty ? params?.row?.purchase_return_qty?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.purchase_return_qty} emed_tid={`stock_value_purchase_return_qty_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_purchase_return_qty_truncated_${params.row.sno}`}>{params?.row?.purchase_return_qty?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_purchase_return_qty_full_${params.row.sno}`}>{params?.row?.purchase_return_qty}</Typography> : <Typography emed_tid={`stock_value_purchase_return_qty_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'transfered_out_qty', headerName: 'Transferred Out Qty', flex: 0.083, type: 'number', 
        renderCell: (params) => (
          <Box emed_tid={`stock_value_transfered_out_qty_${params.row.sno}`}>{params?.row?.transfered_out_qty ? params?.row?.transfered_out_qty?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.transfered_out_qty} emed_tid={`stock_value_transfered_out_qty_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_transfered_out_qty_truncated_${params.row.sno}`}>{params?.row?.transfered_out_qty?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_transfered_out_qty_full_${params.row.sno}`}>{params?.row?.transfered_out_qty}</Typography> : <Typography emed_tid={`stock_value_transfered_out_qty_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'stock_corrected_out', headerName: 'Stock Corrected Out', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_stock_corrected_out_${params.row.sno}`}>{params?.row?.stock_corrected_out ? params?.row?.stock_corrected_out?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.stock_corrected_out} emed_tid={`stock_value_stock_corrected_out_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_stock_corrected_out_truncated_${params.row.sno}`}>{params?.row?.stock_corrected_out?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_stock_corrected_out_full_${params.row.sno}`}>{params?.row?.stock_corrected_out}</Typography> : <Typography emed_tid={`stock_value_stock_corrected_out_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'closing_qty', headerName: 'Closing Qty', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_closing_qty_${params.row.sno}`}>{params?.row?.closing_qty ? params?.row?.closing_qty?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.closing_qty} emed_tid={`stock_value_closing_qty_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_closing_qty_truncated_${params.row.sno}`}>{params?.row?.closing_qty?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_closing_qty_full_${params.row.sno}`}>{params?.row?.closing_qty}</Typography> : <Typography emed_tid={`stock_value_closing_qty_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'batch_no', headerName: 'Batch No', flex: 0.083,
        renderCell: (params) => (
          <Box emed_tid={`stock_value_batch_no_${params.row.sno}`}>{params?.row?.batch_no ? params?.row?.batch_no?.length > 6 ?
            <Tooltip placement='top' title={params?.row?.batch_no} emed_tid={`stock_value_batch_no_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_batch_no_truncated_${params.row.sno}`}>{params?.row?.batch_no?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_batch_no_full_${params.row.sno}`}>{params?.row?.batch_no}</Typography> : <Typography emed_tid={`stock_value_batch_no_empty_${params.row.sno}`}>"-"</Typography>}</Box>
        )
      },
      {
        field: 'expiry_date', headerName: 'Expire Date', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_expiry_date_${params.row.sno}`}>{params?.row?.expiry_date ? (params?.row?.expiry_date) : 0}</Box>
        )
      },
      {
        field: 'purchase_value', headerName: `Purchase Price/Qty (${CurrencySymbol})`, flex: 0.083, type: 'number',
        renderCell: ({row}) => {
          const purchaseValue = AmountFormat(row?.purchase_value || 0)?.replace(`${CurrencySymbol}`, "");
          return(
          <Box emed_tid={`stock_value_purchase_value_${row.sno}`}>{purchaseValue?.length > 10 ? 
            <Tooltip placement='top' title={purchaseValue} emed_tid={`stock_value_purchase_value_tooltip_${row.sno}`}><Typography emed_tid={`stock_value_purchase_value_truncated_${row.sno}`}>{purchaseValue?.slice(0,10) + '...'}</Typography></Tooltip> : 
            <Typography emed_tid={`stock_value_purchase_value_full_${row.sno}`}>{purchaseValue}</Typography>}</Box>
        )}
      },
      {
        field: 'mrp_price', headerName: `MRP/Qty (${CurrencySymbol})`, flex: 0.083, type: 'number',
        renderCell: ({row}) => {
          const mrpPrice = AmountFormat(row?.mrp_price || 0)?.replace(`${CurrencySymbol}`, "");
          return(
          <Box emed_tid={`stock_value_mrp_price_${row.sno}`}>{mrpPrice?.length > 10 ? 
            <Tooltip placement='top' title={mrpPrice} emed_tid={`stock_value_mrp_price_tooltip_${row.sno}`}><Typography emed_tid={`stock_value_mrp_price_truncated_${row.sno}`}>{mrpPrice?.slice(0,10) + '...'}</Typography></Tooltip> : 
            <Typography emed_tid={`stock_value_mrp_price_full_${row.sno}`}>{mrpPrice}</Typography>}</Box>
        )}
      },
      {
        field: 'gst_percentage', headerName: 'GST %', flex: 0.083, type: 'number',
        renderCell: (params) => (
          <Box emed_tid={`stock_value_gst_percentage_${params.row.sno}`}>{params?.row?.gst_percentage ? params?.row?.gst_percentage?.length > 10 ?
            <Tooltip placement='top' title={params?.row?.gst_percentage} emed_tid={`stock_value_gst_percentage_tooltip_${params.row.sno}`}><Typography emed_tid={`stock_value_gst_percentage_truncated_${params.row.sno}`}>{params?.row?.gst_percentage?.slice(0, 10) + '...'}</Typography></Tooltip> :
            <Typography emed_tid={`stock_value_gst_percentage_full_${params.row.sno}`}>{params?.row?.gst_percentage}</Typography> : <Typography emed_tid={`stock_value_gst_percentage_empty_${params.row.sno}`}>0</Typography>}</Box>
        )
      },
      {
        field: 'total_purchase_value', headerName: `Total Purchase Value (${CurrencySymbol})`, flex: 0.083, type: 'number',
        renderCell: ({row}) => {
          const totalPurval = AmountFormat(row?.total_purchase_value || 0)?.replace(`${CurrencySymbol}`, "");
          return(
          <Box emed_tid={`stock_value_total_purchase_value_${row.sno}`}>{totalPurval?.length > 10 ? 
            <Tooltip placement='top' title={totalPurval} emed_tid={`stock_value_total_purchase_value_tooltip_${row.sno}`}><Typography emed_tid={`stock_value_total_purchase_value_truncated_${row.sno}`}>{totalPurval?.slice(0,10) + '...'}</Typography></Tooltip> : 
            <Typography emed_tid={`stock_value_total_purchase_value_full_${row.sno}`}>{totalPurval}</Typography>}</Box>
        )}
      },
      {
        field: 'total_mrp_price', headerName: `Total MRP Value (${CurrencySymbol})`, flex: 0.083, type: 'number',
        renderCell: ({row}) => {
          const totalMrpPrc = AmountFormat(row?.total_mrp_price || 0)?.replace(`${CurrencySymbol}`, "");
          return(
          <Box emed_tid={`stock_value_total_mrp_price_${row.sno}`}>{totalMrpPrc?.length > 10 ? 
            <Tooltip placement='top' title={totalMrpPrc} emed_tid={`stock_value_total_mrp_price_tooltip_${row.sno}`}><Typography emed_tid={`stock_value_total_mrp_price_truncated_${row.sno}`}>{totalMrpPrc?.slice(0,10) + '...'}</Typography></Tooltip> : 
            <Typography emed_tid={`stock_value_total_mrp_price_full_${row.sno}`}>{totalMrpPrc}</Typography>}</Box>
        )}
      },
    ]
    return (
      <Box component={'div'} height={'80vh'} sx={{ backgroundColor: Colors.Background }} emed_tid="stock_value_container">
        <Box component={'div'} className='eMed_Pharma_rts_header' emed_tid="stock_value_header">
          <Box component={'div'} flex={0.8} display={'flex'} emed_tid="stock_value_header_left">
            <div emed_tid="stock_value_total_purchase_value_card">{AmountsCard('Total Purchase Value', this.state.purchaseValue, this.state.purchase, "white", false, null, 'rpt_stkVlu_sal_value')}</div>
            <div emed_tid="stock_value_total_mrp_value_card">{AmountsCard('Total MRP Value', this.state.salesValue, this.state.purchase, "white", false, null, 'rpt_stkVlu_pur_value')}</div>
          </Box>
          <Box flex={0.2} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} marginRight={'0.5vw'} emed_tid="stock_value_header_right">
            <Box component={'div'} display={'flex'} emed_tid="stock_value_header_right_inner">
              <Box component={'div'} display={'flex'} alignItems={'center'} mr={'0.5vw'} emed_tid="stock_value_info_icon_container">
                <Tooltip placement='top' title='Expiry Drug And Inactive Drugs Are Not Included' arrow emed_tid="stock_value_info_tooltip">
                  <Box emed_tid="stock_value_info_icon"><ErrorOutlineIcon color='primary' /></Box>
                </Tooltip>
              </Box>
              <Box component={'div'} width={'11vw'} pr={'0vw'} position={'relative'} top={'0.7vw'} left={'0.5vw'} emed_tid="stock_value_date_picker_container">
                <CommonDatePicker
                  FromDate={this.state.filterDatas.fromDate}
                  ToDate={this.state.filterDatas.toDate}
                  DateIndex={this.state.filterDatas.dateIndex}
                  SelectedDates={this.FilterDate.bind(this)}
                  days={this.state.filterDatas.days}
                  HideAllMenu={true}
                  PharmaDateFilterRestriction={true}
                  fromStockValue={true}
                  emed_tid="stock_value_date_picker"
                />
              </Box>
              <Box component={'div'} display={'flex'} alignItems={'center'} mr={'0.5vw'} emed_tid="stock_value_clear_btn_container">
                <Button className='Common_Btn_Min_Width'
                  onClick={() => {
                    this.state.filterDatas = {
                      'fromDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                      'toDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                      'dateIndex': 1,
                      'days': 30,
                    }
                    this.setState({ filterDatas: this.state.filterDatas }, () => {
                      this.getStockValueData()
                    })
                  }}
                  emed_tid="stock_value_clear_btn"
                ><CancelPresentationIcon color='primary' /></Button>
              </Box>
            </Box>
            <Button className='eMed_Pharma_rts_btn' onClick={() => this.setState({ filterOpen: true })} emed_tid="stock_value_filter_btn">
              <Box component={'img'} src={ImagePaths.Filter.default} alt='filter' height={'2.3vw'} width={'2.3vw'} emed_tid="stock_value_filter_icon" />
            </Button>
            <Button className='eMed_Pharma_rts_btn' disabled={this.state.disabled} emed_tid="stock_value_print_btn">
              <Box component={'img'} src={ImagePaths.LabPrintIcon.default} alt='print' height={'2.3vw'} width={'2.3vw'} onClick={() => this.StockValuePrint()} emed_tid="stock_value_print_icon" />
            </Button>
            <Button className='eMed_Pharma_rts_btn' disabled={this.state.disableBtn} onClick={() => this.getStockValueExcel()} emed_tid="stock_value_export_btn">
              <Box component={'img'} src={ImagePaths.ExportIcon.default} alt='export' height={'2.3vw'} width={'2.3vw'} emed_tid="stock_value_export_icon" />
            </Button>
          </Box>
        </Box>
        <Box component={'div'} className='eMed_Pharma_rts_tbl_card' emed_tid="stock_value_table_container">
          <DataGrid
            className='eMed_Pharma_table'
            rows={this.state.stockValueData}
            columns={columns}
            page={this.state.page}
            pageSize={this.state.pageSize}
            getRowId={(row) => row['sno']}
            columnVisibilityModel={this.state.columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) => this.setState({columnVisibilityModel: newModel})}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: this.gridToolBar,
              NoRowsOverlay: () => (
                <Stack className='eMed_conf_nodata' emed_tid="stock_value_no_records">
                  {t("NoRecordsFound")}
                </Stack>
              )
            }}
            rowCount={this.state.stockValueData?.length}
            onPageChange={(newPage) => { this.setState({ page: newPage }) }}
            onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
            rowsPerPageOptions={[10, 20, 30]}
            headerHeight={40}
            disableSelectionOnClick
            pagination
            loading={this.state.isLoader}
            emed_tid="stock_value_datagrid"
          />
        </Box>

        <Drawer
          anchor={'right'}
          open={this.state.filterOpen}
          ModalProps={{ onBackdropClick: this.ClosePopUp.bind(this) }}
          emed_tid="stock_value_filter_drawer"
        >
          {this.renderFilterScreen()}
        </Drawer>

        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="stock_value_error_toast"
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="stock_value_success_toast"
          />
          : null}
      </Box>
    )
  }
}

export default withTranslation()(StockValue)